import { render, staticRenderFns } from "./guanxi.vue?vue&type=template&id=13676300&scoped=true&"
import script from "./guanxi.vue?vue&type=script&lang=ts&"
export * from "./guanxi.vue?vue&type=script&lang=ts&"
import style0 from "./guanxi.vue?vue&type=style&index=0&id=13676300&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13676300",
  null
  
)

export default component.exports